import { render } from "./Reset.vue?vue&type=template&id=08f6acfe"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"

import "./Reset.vue?vue&type=style&index=0&id=08f6acfe&lang=css"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__